//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "AllowableBloodLoss_info",
};



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Anae/AllowableBloodLoss_info.vue